module.exports = __webpack_public_path__ + "img/cta-left-particle-1.9776f94d.png";